import { Grid, Typography, Stack } from '@mui/material';
import MovingIcon from '@mui/icons-material/MoveToInbox'; // Ikona pro stěhování
import TruckIcon from '@mui/icons-material/LocalShipping'; // Ikona pro nákladní auto
import ExperienceIcon from '@mui/icons-material/StarBorder'; // Ikona pro zkušenosti

const Places = () => {
    return (
        <Grid container sx={{
            width: "100%",
            backgroundColor: "secondary.main",
            padding: "2rem",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            borderRadius: "8px", // Přidání zaoblených rohů
            boxShadow: 3 // Přidání stínu pro lepší vzhled
        }}>
            <Grid item xs={12} md={4} display={"flex"} justifyContent={{ xs: "normal", md: "center" }}>
                <MovingIcon sx={{ color: "primary.main", fontSize: 90 }} />
                <Stack sx={{ justifyContent: "center", marginLeft: 2 }}>
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 'bold' }}>Kde působíme</Typography>
                    <Typography variant="body1" sx={{ color: "white" }}>Mladá Boleslav a okolí</Typography>
                </Stack>
            </Grid>
            <Grid item xs={12} md={4} display={"flex"} justifyContent={{ xs: "normal", md: "center" }}>
                <TruckIcon sx={{ color: "primary.main", fontSize: 96 }} />
                <Stack sx={{ justifyContent: "center", marginLeft: 2 }}>
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 'bold' }}>Naše služby</Typography>
                    <Typography variant="body1" sx={{ color: "white" }}>Profesionální stěhování s péčí</Typography>
                </Stack>
            </Grid>
            <Grid item xs={12} md={4} display={"flex"} justifyContent={{ xs: "normal", md: "center" }}>
                <ExperienceIcon sx={{ color: "primary.main", fontSize: 96 }} />
                <Stack sx={{ justifyContent: "center", marginLeft: 2 }}>
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 'bold' }}>Naše zkušenosti</Typography>
                    <Typography variant="body1" sx={{ color: "white" }}>Jsme zkušení v našem oboru</Typography>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default Places;